import React, { useState, useEffect, useCallback } from "react";
import AddCircle from "@mui/icons-material/AddCircleRounded";
import FileCircle from "@mui/icons-material/FileCopyRounded";
import SearchIcon from "@mui/icons-material/SearchTwoTone";
import ModeEditOutlineRounded from "@mui/icons-material/ModeEditOutlineRounded";
import { InputGroup, Button, FormControl, Col, Accordion, Card, Row, Spinner, Modal } from "react-bootstrap";
import _ from "lodash";
import ApiAmusementServiceReserveItem from "../../../core/api/api.amusementServiceReserveItem";
import ApiAmusementService from "../../../core/api/api.amusementService";
import ApiSupplier from "../../../core/api/api.supplier";
import CreateOrEditAmusementServiceReserveItem from "./CreateOrEdit";
import CreateOrEditAmusementServicePackageReserveItem from "./CreateOrEditPackage";
import { FormProvider, useForm, Controller } from "react-hook-form";
import DataGrid from "./DataGrid";
import ChangeOrderReserveItem from "./ChangeOrderReserveItem";
import { useNavigate, useLocation } from "react-router-dom";
import { tools } from "../../../core/utils/tools";
import SwapVert from "@mui/icons-material/SwapVert";
import SelectComponent from "../_Components/ReactSelectComponent";
import GroupEditingModal from "./GroupEditingModal";
import SwalMessage from "../_Components/SwalMessage";
import { NumericFormat } from "react-number-format";
import { TextField } from "@mui/material";
import ReserveItemPricingAndCommissionModal from "./ReserveItemPricingAndCommissionModal";
import GlobalFormControl from "../_Components/GlobalFormControl";
import * as XLSX from "xlsx";
import Swal from "sweetalert2";
import ApiRegion from "../../../core/api/api.region";
import ApiHome from "../../../core/api/api.home";


const supplierSettlementTypeEnum = [
  { value: "1", label: "تسویه در وضعیت بلیط رزرو" },
  { value: "2", label: "تسویه در وضعیت بلیط استفاده شده" },
];
const issueTicketTypeEnum = [
  { value: "1", label: "صدور بلیط خارج از سامانه" },
  { value: "2", label: "صدور بلیط توسط سامانه" },
];
const optionsArray = [
  { value: "", label: "---------------" },
  { value: "1", label: "دارد" },
  { value: "0", label: "ندارد" },
];
const isActiveOptionsArray = [
  { value: "", label: "---------------" },
  { value: "1", label: "فعال" },
  { value: "0", label: "غیر فعال" },
];
const AmusementServiceReserveItem = () => {
  const [showModalReserveItem, setShowModalReserveItem] = useState(false);
  const [showModalPackageReserveItem, setShowModalPackageReserveItem] = useState(false);
  const [showModalReserveItemOrder, setShowModalReserveItemOrder] = useState(false);
  const [selectedReserveItem, setSelectedReserveItem] = useState(null);
  const [listData, setListData] = useState([{}]);
  const [services, setServices] = useState([]);
  const [suppliers, setSuppliers] = useState([]);
  const [modalType, setModalType] = useState();
  const [selectedCheckBoxes, setSelectedCheckBoxes] = useState([]);
  const [isUploading, setIsUploading] = useState(false); //loading
  const [isDownloading, setIsDownloading] = useState(false); //loading
  const [showModalFile, setShowModalFile] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [cities, setCities] = useState([])
  const [selectedCities, setSelectedCities] = useState([])


  const {
    register,
    handleSubmit,
    control,
    formState: { errors, isSubmitting },
    getValues,
    setValue,
    watch,
    reset,
  } = useForm({});
  const methods = { register, handleSubmit, control, formState: { errors, isSubmitting }, getValues, setValue, watch };
  const navigate = useNavigate();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);

  const pageSizeFromUrl1 = searchParams.get("pageSize");
  const pageSizeFromUrl = !_.isEmpty(pageSizeFromUrl1) ? _.toNumber(pageSizeFromUrl1) : 10;

  const pageNumberFromUrl1 = searchParams.get("pageNumber");
  const pageNumberFromUrl = !_.isEmpty(pageNumberFromUrl1) ? _.toNumber(pageNumberFromUrl1) : 1;
  const [showModalGroupEditing, setShowModalGroupEditing] = useState(false); //نمایش مدال ویرایش گروهی
  const [showModalReserveItemPricingAndCommission, setShowModalReserveItemPricingAndCommission] = useState(false); //نمایش مدال قیمت گذاری و به‌روزرسانی گروه‌های تخفیف و کمیسیون
  const [reserveItemTypes, setReserveItemTypes] = useState([])
  useEffect(() => {
    (async () => {
      try {
        const result = await ApiAmusementServiceReserveItem.getAll({
          pageSize: !_.isEmpty(pageSizeFromUrl) ? getValues("pageSize") : pageSizeFromUrl,
          pageNumber: !_.isEmpty(pageNumberFromUrl) ? getValues("pageNumber") : pageNumberFromUrl,
          globalSearch: searchParams.get("globalSearch"),
          supplierId: searchParams.get("supplierId"),
          amusementServiceIds: _.toString(searchParams.get("amusementServiceIds")),
          reserveItemType: searchParams.get("reserveItemType"),
          supplierAutoSettlement: searchParams.get("supplierAutoSettlement"),
          supplierSettlementType: searchParams.get("supplierSettlementType"),
          reservationByPhone: searchParams.get("reservationByPhone"),
          isActive: searchParams.get("isActive"),
          issueTicketType: searchParams.get("issueTicketType"),
        });

        setListData(result);
        setValue("totalCount", result.totalCount);
        const data = await ApiAmusementService.getAllServices();
        if (data) {
          setServices(data);
        }

        const suppliers = await ApiSupplier.getAllSuppliersName();
        setSuppliers(suppliers);

        const itemTypes = await ApiHome.getEnums({ enumName: "AmusementServiceReserveItemType" })
        setReserveItemTypes(itemTypes.data.map(item => ({ label: item.title, value: item.id })))

        const allAmusementCityList = await ApiRegion.getAllCity();
        setCities(allAmusementCityList.map(city =>
        ({
          label: city.id + "-" + city.name,
          value: city.id
        })
        ))
        const suppliersFormattedArray = suppliers.map((item) => ({ id: item.id, title: item.companyName }));
        const supplierSettlementTypeFormattedArray = supplierSettlementTypeEnum.map((item) => ({
          id: item.value,
          title: item.label,
        }));
        const issueTicketTypeFormattedArray = issueTicketTypeEnum.map((item) => ({
          id: item.value,
          title: item.label,
        }));
        const optionsFormattedArray = optionsArray.map((item) => ({ id: item.value, title: item.label }));
        const isActiveOptionsFormattedArray = isActiveOptionsArray.map((item) => ({
          id: item.value,
          title: item.label,
        }));

        const formInputs = [
          { name: "globalSearch", type: "text" },
          { name: "pageSize", type: "number" },
          { name: "pageNumber", type: "number" },
          { name: "amusementServiceIds", type: "multiSelect", isMulti: true, data },
          { name: "reserveItemType", type: "multiSelect", isMulti: false, data: itemTypes.data.map(item => ({ label: item.title, value: item.id })) },
          { name: "supplierId", type: "multiSelect", isMulti: false, data: suppliersFormattedArray },
          {
            name: "supplierSettlementType",
            type: "multiSelect",
            isMulti: false,
            data: supplierSettlementTypeFormattedArray,
          },
          { name: "supplierAutoSettlement", type: "multiSelect", isMulti: false, data: optionsFormattedArray },
          { name: "reservationByPhone", type: "multiSelect", isMulti: false, data: optionsFormattedArray },
          { name: "isActive", type: "multiSelect", isMulti: false, data: isActiveOptionsFormattedArray },
          { name: "issueTicketType", type: "multiSelect", isMulti: false, data: issueTicketTypeFormattedArray },
        ];
        tools.setInputsValues_ReactHookFrom(setValue, searchParams, formInputs);
      } catch (error) {
      }
    })();
  }, []);

  const onSubmit = async (data) => {
    data.amusementServiceIds = !_.isEmpty(data.amusementServiceIds)
      ? String(data.amusementServiceIds?.map((item) => item.value))
      : data.amusementServiceIds;
    data.reserveItemType = data.reserveItemType?.value
    data.supplierSettlementPrice = data.supplierSettlementPrice?.replace(",", "")
    data.issueTicketType = data?.issueTicketType?.value;
    data.supplierId = data.supplierId?.value;
    data.supplierSettlementType = data?.supplierSettlementType?.value;
    data.supplierAutoSettlement = data.supplierAutoSettlement?.value;
    data.reservationByPhone = data.reservationByPhone?.value;
    data.isActive = data.isActive?.value;
    tools.setPageNumber(data, searchParams, setValue);
    const apiData = await ApiAmusementServiceReserveItem.getAll(data);
    //ارسال داده های فرم به تابع پس از حذف آیتم های اضافه
    var queryString = tools.createQueryStringFromFromData(_.omit(data, ["totalPages", "totalCount"]));
    navigate(`/amusementServiceReserveItem?${queryString}`);
    setSelectedCheckBoxes([]);
    setListData(apiData);
    setValue("totalCount", apiData.totalCount);
  };
  const handleModalGroupEditing = () => {
    if (selectedCheckBoxes == 0) {
      SwalMessage({
        title: "ابتدا آیتم های مورد نظر را انتخاب نمایید.",
        iSsuccess: false,
        timer: 4000,
      });
    } else setShowModalGroupEditing(true);
  };

  //نمایش داده ها روی اکسل
  const handleDownload = useCallback(async () => {
    setIsDownloading(true)
    const cities = selectedCities.map(city => city.value)
    const amusementItems = (await ApiAmusementServiceReserveItem.getAllServicesWithItemsByCityId({ cityIds: cities.join(",") }))

    const rows = [];

    amusementItems.forEach((item) => {
      item.amusementServiceReserveItems.map(service => {
        rows.push({
          serviceId: item.id,
          itemId: service.id,
          تفریح: item.name,
          آیتم: service.title,
          شهر: item.cityName,
          'قیمت اصلی': service.originalPrice,
          قیمت: service.price,
          'پرداختی به تامین کننده': service.supplierSettlementPrice,
          "تسویه خودکار با تامین کننده": service.supplierAutoSettlement ? "فعال" : "غیرفعال",
          "نحوه تسویه": supplierSettlementTypeEnum.find(i => i.value == service.supplierSettlementType)?.label || "",
          "نوع صدور بلیط": issueTicketTypeEnum.find(i => i.value == service.issueTicketType)?.label || "",
          'ساعت اتمام فروش': service.reservationExpirationTime,
          "زمان اجرا برنامه": service.executionTime,
          "حداقل تعداد": service.minimumReserveCountPerDay,
          "ظرفیت روزانه": service.defaultReserveCountPerDay,
          'شماره تماس تلفنی': service.reservationByPhone || "",
          // "تامین کننده": service.supplierCompanyName
        });
      })
    });


    const worksheet = XLSX.utils.json_to_sheet(rows);

    // تنظیم عرض ستون‌ها)
    worksheet["!cols"] = [
      { wch: 10 },  // serviceId
      { wch: 5 }, // ItemId
      { wch: 20 }, // تفریح
      { wch: 20 }, // آیتم
      { wch: 15 }, // شهر
      { wch: 10 }, // قیمت اصلی
      { wch: 10 }, // قیمت
      { wch: 15 }, // پرداختی به تامین کننده
      { wch: 20 }, // تسویه خودکار با تامین کننده
      { wch: 25 }, // نحوه تسویه
      { wch: 20 }, // نوع صدور بلیط
      { wch: 15 }, // ساعت اتمام فروش
      { wch: 10 }, // زمان اجرا برنامه
      { wch: 10 }, // حداقل تعداد
      { wch: 10 }, // ظرفیت روزانه
      { wch: 15 }, // شماره تماس تلفنی
      // { wch: 25 }, // تامین کننده
    ];

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "amusement-reserve-items");
    XLSX.writeFile(workbook, `amusement-reserve-items.xlsx`);
    setIsDownloading(false)
  }, [listData, selectedCities]);

  const handleCloseFileModal = useCallback(() => {
    setShowModalFile(false);
  }, [])

  const handleFileSelect = useCallback((e) => {
    const file = e.target.files[0]; //  اولین فایل
    if (file && !file?.name?.includes("amusement-reserve-items")) {
      SwalMessage({ title: "فایل انتخاب شده مربوط به گروه های تخفیف نمی باشد!", iSsuccess: false });
      e.target.value = null; // ریست کردن input فایل
      return;
    }
    if (file) {
      setSelectedFile(file);
    }
  }, [])


  const handleUpload = useCallback(async () => {
    if (!selectedFile) {
      SwalMessage({ title: "لطفاً فایل را انتخاب کنید!", iSsuccess: false });
      return;
    }

    try {
      setIsUploading(true);

      const formData = new FormData();
      formData.append("file", selectedFile);

      const response = await ApiAmusementServiceReserveItem.updateAmusementServiceReserveItemsByExcel(formData);

      if (!response || !response.data) {
        SwalMessage({ title: response != null ? response.message : "خطا در آپلود فایل", iSsuccess: false });
        return;
      }
      const { updated, errors } = response.data;
      // اگر هیچ خطایی نبود 
      if (!errors || errors.length === 0) {
        SwalMessage({ title: response.message, iSsuccess: response.succeeded });
        handleCloseFileModal();
        return;
      }

      // ساخت خروجی HTML
      let HtmlOutPut = "";
      // اگر رکورد آپدیت شده وجود دارد
      if (updated > 0) {
        HtmlOutPut += `
          <div class='border rounded-3 text-end py-2 px-4 mb-5 bg-light-success border-light-success text-dark-success-msg-box'>
            <span> تعداد ${updated} آیتم رزرو با موفقیت به‌روزرسانی شد. </span>
          </div>
        `;
      }

      // پیام‌های خطا 
      HtmlOutPut += errors
        .map((err) => {
          return `
            <div class='border rounded-3 text-end py-2 px-4 mb-5 bg-light-danger border-light-danger text-dark-danger-msg-box'>
              <span>${err}</span>
            </div>
          `;
        }).join("");

      // نمایش SweetAlert خروجی
      const swalWithBootstrapButtons = Swal.mixin({
        customClass: {
          confirmButton: "btn btn-success mr-2 px-5",
          cancelButton: "btn btn-danger px-5",
        },
        buttonsStyling: false,
      });

      swalWithBootstrapButtons.fire({
        title: "عملیات به روزرسانی آیتم های رزرو",
        icon: "info",
        html: HtmlOutPut,
        showConfirmButton: false,
        showCancelButton: true,
        cancelButtonText: "بستن",
      });

      document.getElementById("submitButton")?.click();

    } catch (err) {
      SwalMessage({ title: "خطا در آپلود فایل", iSsuccess: false });
    } finally {
      setIsUploading(false);
    }
  }, [selectedFile]);

  return (
    <div>
      <div className={`card card-custom`}>
        {/* Start Box Header */}
        <div className="card-header border-0 pt-5">
          <h3 className="card-title align-items-start flex-column">
            <span className="card-label font-weight-bolder text-dark">مدیریت آیتم های رزرو تفریحات</span>
            <span className="text-muted mt-3 font-weight-bold font-size-sm">لیست آیتم های رزرو ثبت شده</span>
          </h3>
          <div className="card-toolbar">
            {/* <Button className="mr-2" onClick={() => exportToExcel()}>
              <UploadCircle className="mr-1" />
              آپلود اکسل
            </Button> */}
            <Button className="mr-2" onClick={() => handleModalGroupEditing()}>
              <ModeEditOutlineRounded className="mr-1" />
              ویرایش گروهی
            </Button>

            <Button className="mr-2" onClick={() => setShowModalFile(true)}>
              <ModeEditOutlineRounded className="mr-1" />
              ویرایش گروهی از طریق اکسل
            </Button>


            <Button
              className="mr-2"
              onClick={() => {
                setModalType(1);
                setSelectedReserveItem({ id: 0 });
                setShowModalReserveItem(true);
              }}
            >
              <AddCircle className="mr-1" />
              ایجاد آیتم رزرو
            </Button>
            <Button
              className="mr-2"
              onClick={() => {
                setSelectedReserveItem({ id: 0 });
                setShowModalPackageReserveItem(true);
              }}
            >
              <AddCircle className="mr-1" />
              ایجاد پکیج آیتم رزرو
            </Button>
            <div className="card-toolbar">
              <Button
                variant="success"
                onClick={() => {
                  setShowModalReserveItemOrder(true);
                }}
              >
                <SwapVert className="mr-1" />
                ترتیب نمایش
              </Button>
            </div>
          </div>
        </div>
        {/*Start body */}
        <div className="card-body pt-3 pb-0">
          {/* search box */}
          <div className="border-top pt-3">
            <FormProvider {...methods}>
              <form id="form" key={1} onSubmit={methods.handleSubmit(onSubmit)}>
                {/* search box */}
                {/* table */}
                <Accordion>
                  <Card>
                    <Accordion.Header as={Card.Header} variant="link">
                      <Card.Title className="py-0 pl-0 fs-normal text-gray">جستجو پیشرفته</Card.Title>
                    </Accordion.Header>
                    <Accordion.Body>
                      <Card.Body>
                        <Row>
                          <Col xs="12" sm="6" xl="3" className="tb-reponsive px-2">
                            <Controller
                              name="amusementServiceIds"
                              control={control}
                              render={({ field }) => (
                                <SelectComponent
                                  className="w-100 mt-5"
                                  placeholder="انتخاب تفریح"
                                  options={services?.map((item) => ({
                                    value: item.id,
                                    label: item.name,
                                    type: "service",
                                  }))}
                                  field={field}
                                  isMulti
                                />
                              )}
                            />
                          </Col>
                          <Col xs="12" sm="6" xl="3" className="tb-reponsive px-2">
                            <Controller
                              name="issueTicketType"
                              control={control}
                              render={({ field }) => (
                                <SelectComponent
                                  className="w-100 mt-5"
                                  placeholder="نوع صدور بلیط"
                                  options={[{ value: "", label: "---------------" }, , ...issueTicketTypeEnum]}
                                  field={field}
                                />
                              )}
                            />
                          </Col>

                          <Col xs="12" sm="6" xl="3" className="tb-reponsive px-2">
                            <Controller
                              control={control}
                              name={"reservationByPhone"}
                              render={({ field }) => (
                                <SelectComponent
                                  className="w-100 mt-5"
                                  placeholder="تماس تلفنی "
                                  options={optionsArray}
                                  field={field}
                                />
                              )}
                            />
                          </Col>
                          <Col xs="12" sm="6" xl="3" className="tb-reponsive px-2">
                            <Controller
                              control={control}
                              name={"isActive"}
                              render={({ field }) => (
                                <SelectComponent
                                  className="w-100 mt-5"
                                  placeholder="فعال"
                                  options={isActiveOptionsArray}
                                  field={field}
                                />
                              )}
                            />
                          </Col>
                          <Col xs="12" sm="6" xl="3" className="tb-reponsive px-2">
                            <Controller
                              name="supplierId"
                              control={control}
                              render={({ field }) => (
                                <SelectComponent
                                  className="w-100 mt-5"
                                  placeholder="تامین کننده"
                                  options={suppliers?.map((item) => ({
                                    value: item.id,
                                    label: item.companyName,
                                  }))}
                                  field={field}
                                />
                              )}
                            />
                          </Col>
                          <Col xs="12" sm="6" xl="3" className="tb-reponsive px-2">
                            <Controller
                              name="supplierSettlementPrice"
                              control={control}
                              render={({ field: { onChange, value } }) => (
                                <NumericFormat
                                  customInput={TextField}
                                  label="قیمت تسویه با تامین کننده"
                                  type="search"
                                  margin="normal"
                                  variant="outlined"
                                  size="small"
                                  value={value}
                                  onChange={onChange}
                                  thousandSeparator=","
                                  onKeyDown={(e) => {
                                    if (e.key === "Escape") {
                                      e.stopPropagation()
                                    }
                                  }}
                                />
                              )}
                            />
                          </Col>
                          <Col xs="12" sm="6" xl="3" className="tb-reponsive px-2">
                            <Controller
                              name="supplierSettlementType"
                              control={control}
                              render={({ field }) => (
                                <SelectComponent
                                  className="w-100 mt-5"
                                  placeholder="نحوه تسویه با تامین کننده"
                                  options={[{ value: "", label: "---------------" }, ...supplierSettlementTypeEnum]}
                                  field={field}
                                />
                              )}
                            />
                          </Col>
                          <Col xs="12" sm="6" xl="3" className="tb-reponsive px-2">
                            <Controller
                              control={control}
                              name={"supplierAutoSettlement"}
                              render={({ field }) => (
                                <SelectComponent
                                  className="w-100 mt-5"
                                  placeholder="تسویه خودکار با تامین کننده"
                                  options={optionsArray}
                                  field={field}
                                />
                              )}
                            />
                          </Col>

                          <Col xs="12" sm="6" xl="3" className="tb-reponsive px-2">
                            <Controller
                              name="reserveItemType"
                              control={control}
                              render={({ field }) => (
                                <SelectComponent
                                  className="w-100 mt-5"
                                  placeholder="نوع آیتم"
                                  options={reserveItemTypes}
                                  field={field}
                                />
                              )}
                            />
                          </Col>
                        </Row>
                        <Row className="mt-3">
                          <Col xs="auto" className="tb-reponsive px-2 px-3 mt-3">
                            <Button variant="success" type="submit" disabled={isSubmitting}>
                              {isSubmitting && <Spinner animation="border" variant="warning" size="sm" />}
                              <SearchIcon />
                              جستجو
                            </Button>
                          </Col>
                          <Col xs="auto" className="tb-reponsive px-2 px-3 mt-3">
                            <Button
                              variant="light-danger"
                              type="submit"
                              disabled={isSubmitting}
                              onClick={() => tools.handleResetAdvanceSearchBox(watch, reset)}
                            >
                              {isSubmitting && <Spinner animation="border" variant="warning" size="sm" />}
                              <i className="fas fa-refresh text-small"></i>
                              حذف جستجو{" "}
                            </Button>
                          </Col>
                        </Row>
                      </Card.Body>
                    </Accordion.Body>
                  </Card>
                </Accordion>
                <div className="">
                  <InputGroup className="my-3">
                    <Controller
                      name="globalSearch"
                      control={control}
                      render={({ field: { onChange, value } }) => (
                        <GlobalFormControl
                          type="text"
                          aria-describedby="basic-addon1"
                          placeholder="جستجو ..."
                          name="globalSearch"
                          value={value || ""}
                          onChange={onChange}
                        />
                      )}
                    />

                    <Button variant="secondary" type="submit" disabled={isSubmitting}>
                      <SearchIcon />
                    </Button>
                  </InputGroup>
                </div>

                <Col xs="12" className="tb-reponsive px-0">
                  <DataGrid
                    data={listData}
                    setShowModalReserveItem={setShowModalReserveItem}
                    setShowModalPackageReserveItem={setShowModalPackageReserveItem}
                    setSelectedReserveItem={setSelectedReserveItem}
                    setModalType={setModalType}
                    setSelectedCheckBoxes={setSelectedCheckBoxes}
                    selectedCheckBoxes={selectedCheckBoxes}
                    setShowModalReserveItemPricingAndCommission={setShowModalReserveItemPricingAndCommission}
                  />
                </Col>
                {showModalReserveItemOrder && (
                  <ChangeOrderReserveItem
                    showModalReserveItemOrder={showModalReserveItemOrder}
                    setShowModalReserveItemOrder={setShowModalReserveItemOrder}
                  />
                )}
              </form>
            </FormProvider>
            {showModalReserveItem && (
              <CreateOrEditAmusementServiceReserveItem
                showModalReserveItem={showModalReserveItem}
                setShowModalReserveItem={setShowModalReserveItem}
                selectedReserveItem={selectedReserveItem}
                suppliers={suppliers}
                modalType={modalType}
              />
            )}
            {showModalPackageReserveItem && (
              <CreateOrEditAmusementServicePackageReserveItem
                showModalReserveItem={showModalPackageReserveItem}
                setShowModalReserveItem={setShowModalPackageReserveItem}
                selectedReserveItem={selectedReserveItem}
                suppliers={suppliers}
              />
            )}
            {showModalGroupEditing && (
              <GroupEditingModal
                showModalGroupEditing={showModalGroupEditing}
                setShowModalGroupEditing={setShowModalGroupEditing}
                suppliers={suppliers}
                selectedItem={selectedCheckBoxes}
              />
            )}
            {showModalReserveItemPricingAndCommission && (
              <ReserveItemPricingAndCommissionModal
                showModalReserveItemPricingAndCommission={showModalReserveItemPricingAndCommission}
                setShowModalReserveItemPricingAndCommission={setShowModalReserveItemPricingAndCommission}
                suppliers={suppliers}
                selectedReserveItem={selectedReserveItem}
              />
            )}

            {/* کدهای مربوط به مدال آپلود فایل */}
            <Modal show={showModalFile} onHide={handleCloseFileModal}>
              <Modal.Header closeButton>
                <Modal.Title>  ویرایش گروهی آیتم های رزرو</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <div className="mb-5">
                  <SelectComponent
                    className=" mt-5"
                    placeholder="شهر"
                    options={cities}
                    isMulti
                    onChange={(selectedCities) => {
                      setSelectedCities(selectedCities)
                    }}
                    value={selectedCities}
                  />
                  <Button
                    variant="primary"
                    onClick={handleDownload}
                    disabled={isDownloading}   //  در زمان دانلود
                    className="w-25 mt-2"
                  >
                    {isDownloading ? "در حال دانلود..." : "دانلود"}
                  </Button>
                </div>
                <div className="w-100 bg-dark" style={{ height: 1 }} />
                <div>
                  <TextField
                    margin="normal"
                    variant="outlined"
                    size="small"
                    type="file"
                    accept=".xlsx"
                    dir="ltr"
                    sx={{
                      "& input[type=file]::file-selector-button": {
                        display: "none",
                      },
                      "& input[type=file]::-webkit-file-upload-button": {
                        display: "none",
                      },
                      "& input[type=file]": {
                        padding: "10px", // هرچقدر بخوای
                        cursor: "pointer",
                      }
                    }}
                    onInput={handleFileSelect}
                  />
                  <Button
                    variant="primary"
                    onClick={handleUpload}
                    disabled={isUploading || !selectedFile}   //  در زمان آپلود
                    className="w-25"
                  >
                    {isUploading ? "در حال آپلود..." : "آپلود"}
                  </Button>
                </div>
              </Modal.Body>
              <Modal.Footer>
                <Button variant="secondary" onClick={handleCloseFileModal}>
                  بستن
                </Button>
              </Modal.Footer>
            </Modal>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AmusementServiceReserveItem;
